export default {
  gray:   { stroke: '#5E6678', fill: '#ECEFF3', picker: '#C7D0DB'},
  blue:   { stroke: '#2C334E', fill: '#E5EAF5', picker: '#B0C5F3'},
  orange: { stroke: '#533827', fill: '#F3E6DE', picker: '#F5C4A3'},
  red:    { stroke: '#552A32', fill: '#F0E0E3', picker: '#E79DAC'},
  green:  { stroke: '#2C4F42', fill: '#E1EFEA', picker: '#B0E8D2'},
  purple: { stroke: '#352C4E', fill: '#E2E0F0', picker: '#B5ADEB'},
  aqua:   { stroke: '#2C414E', fill: '#DEEDF3', picker: '#A7DDF1'},
  pink:   { stroke: '#4C2B50', fill: '#EFDFF1', picker: '#E6ACEC'},
}